import { exportToCsv } from 'src/services/exports/csv';

export const getDataCsv = (data: any[]) => {
    const groupData: string[][] = [
        [
            'Case Number',
            'Client',
            'Service Type',
            'Service Location',
            'Order Type',
            'Session Date',
            'Start Time',
            'End Time',
            'Total Units',
            'Min per Unit',
            'Total Hours',
            'Type',
            'External Rate per Hour',
            'Internal Rate per Hour',
            'Total',
            'Covered by invoice payment, %',
            'Covered by invoice payment, $',
            'Left to Pay (underpaid invoice)',
            'Advance Paid',
            'Total Payable',
        ],
    ];

    data.forEach((itShow) => {
        delete itShow.clientLink;
        delete itShow.colorColumn;
        const dataShow: any = Object.values(itShow);

        groupData.push(dataShow);
    });

    const last = data[data.length - 1];

    groupData[data.length] = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        last.total,
        '',
        last.coveredByInvoicePaymentAmount,
        '',
        last.advancePaid,
        last.totalPayable,
    ];

    return exportToCsv('payroll.csv', groupData);
};
